import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import ToolbarMenu from './ToolbarMenu';
import ToolButton from './ToolButton';
import stickyStackSVG from '../assets/icons/stickyStack.svg';
import shapeNoteSVG from '../assets/icons/shapeNote.svg';
import { svgToIcon } from '../utils/svg';
import WhiteboardController from '../controllers/WhiteboardController';
import styles from '../styles.module.css';
import classNames from 'classnames';
import { noteColorPalette } from '../utils/DefaultsManager';

// Stylus toolbar sub-menu for choosing note color.
const NoteMenu = () => {
  const controller = useController(WhiteboardController);
  const { shapeDragManager } = controller;

  const randomStylusColor = () => {
    const color =
      noteColorPalette[(noteColorPalette.length * Math.random()) | 0];
    const stylus = controller.noteStackStylus;
    stylus.setFillColor(color);
    return stylus;
  };

  return (
    <ToolbarMenu columns={2}>
      {controller.noteStyluses.map((stylus, i) => {
        return (
          <ToolButton
            key={i}
            draggable={true}
            onDragStart={e => shapeDragManager.startDrag(e, stylus)}
            onClick={event => {
              controller.actionSetStylus(stylus);
              controller.actionSetStylusMenu(null);
              event.stopPropagation();
            }}
            testId={`note-${stylus.fillColor()}`}
          >
            {svgToIcon(shapeNoteSVG, { color: stylus.fillColor() })}
          </ToolButton>
        );
      })}
      <hr
        style={{ width: '100%', border: '1px solid var(--theme-light-border)' }}
      />
      <ToolButton
        className={classNames(styles.toolButtonWithSideLabel)}
        draggable={true}
        onDragStart={e => shapeDragManager.startDrag(e, randomStylusColor())}
        onClick={event => {
          controller.actionSetStylus(randomStylusColor());
          controller.actionSetStylusMenu(null);
          event.stopPropagation();
        }}
      >
        {svgToIcon(stickyStackSVG)}
        Stack
      </ToolButton>
    </ToolbarMenu>
  );
};

export default ApplicationView(NoteMenu);
